import { Navigate } from 'react-router-dom'

import { useAuth } from './authContext'

/** Renders its children only when signed in; otherwise sends you to the login page. */
export default function RequireAuth({ children }) {
  const { session } = useAuth()
  return session ? children : <Navigate to="/login" replace />
}
